import API from '../vue_shared/api'

interface Account {
  civicplus_sso_feature_flag: boolean
}

async function signOut(account: Account): Promise<void> {
  API.signOut().then(() => {
    localStorage.clear()

    if (account.civicplus_sso_feature_flag) {
      const ssoSignOutUrl = new URL(
        '/connect/endsession',
        import.meta.env.VITE_CP_AUTH_URL
      )
      window.location.href = ssoSignOutUrl.href
    } else {
      window.location.reload()
    }
  })
}

export default signOut
